import { createFileRoute } from "@tanstack/react-router";

import AuthCallback from "../pages/AuthCallback";

interface AuthCallbackSearch {
  auth_error?: string;
  auth_error_id?: string;
  auth_error_reason?: string;
  return_to?: string;
}

function parseAuthCallbackSearch(search: Record<string, unknown>): AuthCallbackSearch {
  return Object.fromEntries(
    ["auth_error", "auth_error_id", "auth_error_reason", "return_to"]
      .filter((key) => typeof search[key] === "string")
      .map((key) => [key, search[key]]),
  ) as AuthCallbackSearch;
}

export const Route = createFileRoute("/_shell/auth/callback")({
  validateSearch: parseAuthCallbackSearch,
  component: AuthCallbackRoute,
});

function AuthCallbackRoute() {
  const { return_to: returnTo } = Route.useSearch();
  return <AuthCallback returnTo={returnTo} />;
}
